import {
    BULKUPDATESTATUSPARTNER_SUCCESS,
    BULKUPDATESTATUSPARTNER_FAILED,
    RESET_BULKUPDATESTATUSPARTNER,
    LOADING_BULKUPDATESTATUSPARTNER,
    NETWORK_ERROR_BULKUPDATESTATUSPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetBulkUpdateStatusPartner = () => {
    return { type: RESET_BULKUPDATESTATUSPARTNER };
};

const partnerBulkUpdateStatus = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BULKUPDATESTATUSPARTNER });
    await partnerServices
        .post("bulkUpdateStatus", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerBulkUpdateStatussuccess(res.data));
                    break;
                default:
                    dispatch(partnerBulkUpdateStatusFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BULKUPDATESTATUSPARTNER,
                payload: err
            });
        });
};

function partnerBulkUpdateStatussuccess(data) {
    return {
        type: BULKUPDATESTATUSPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerBulkUpdateStatusFailed(data) {
    return {
        type: BULKUPDATESTATUSPARTNER_FAILED,
        payload: data,
    };
}

export { resetBulkUpdateStatusPartner, partnerBulkUpdateStatus }